const SENSITIVE_CONTENT = "sensitive-content";

export default SENSITIVE_CONTENT;
